var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0001 0C17.4668 0 0 16.5057 0 38.8001C0 50.4616 4.77927 60.5384 12.5623 67.4986C13.2156 68.0834 13.61 68.9026 13.6368 69.7794L13.8546 76.8946C13.9243 79.1641 16.2686 80.641 18.3454 79.7241L26.2849 76.2193C26.9579 75.9225 27.7121 75.8673 28.4213 76.0625C32.0697 77.0658 35.9527 77.6002 40.0001 77.6002C62.5334 77.6002 80.0002 61.0946 80.0002 38.8001C80.0002 16.5057 62.5334 0 40.0001 0Z",
    fill: "url(#paint0_radial_374_167)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9811 50.1472L27.7312 31.5056C29.6002 28.5399 33.6026 27.8015 36.407 29.9048L45.7523 36.9138C46.6098 37.557 47.7896 37.5536 48.6435 36.9055L61.2648 27.3268C62.9494 26.0483 65.1485 28.0643 64.021 29.8534L52.271 48.4952C50.4018 51.4607 46.3994 52.1993 43.5952 50.0958L34.2496 43.0867C33.3923 42.4436 32.2123 42.447 31.3586 43.095L18.7371 52.6739C17.0526 53.9522 14.8536 51.9362 15.9811 50.1472Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_374_167",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.3979 79.5722) scale(87.1678 87.1677)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609754,
    stopColor: "#A033FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934823,
    stopColor: "#FF5280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7061"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagingIcon);
export default __webpack_public_path__ + "static/media/messaging_icon.52e9b5df7903abb2cb4385f7701bd590.svg";
export { ForwardRef as ReactComponent };